export default __webpack_public_path__ + "static/media/ActivityMobileActive.f3be8a3d.svg";